import React from "react";
import Footer from "../components/footer/Footer";
import ContactBanner from "../components/contactbanner/ContactBanner";
import OurLocations from "../components/ourlocations/OurLocations";
import { Helmet } from "react-helmet";
import MegaHeader from "../components/MegaHeader/MegaHeader";
import { useTranslation } from "react-i18next";
import MegaMenu from "../components/MegaMenu/MegaMenu";
import ReCaptchaProvider from "../components/ReCaptchaProvider/ReCaptchaProvider";

const ContactUs = () => {
  const { t: tmetaTitles } = useTranslation("metaTitles");
  const metaTitle = tmetaTitles("contactUsTitle", { returnObjects: false });

  const { t: tfooter } = useTranslation("footer");
  const footerCtaContent = tfooter("footerCtaContent", {
    returnObjects: true,
  });
  return (
    <>
      <Helmet>
        <title>Contact Us | Bitsclan</title>
        <meta
          name="description"
          content="Need expert support for your project? Bitsclan’s dedicated client support team is ready to assist you anywhere, anytime. Get in touch now and let’s make your vision a reality!"
        />
      </Helmet>
      <MegaMenu />
      <ContactBanner />
      <Footer />
    </>
  );
};

export default ContactUs;
